export const formatNumber = (value, decimals = 2) => {
  if (value === null || value === undefined || isNaN(value)) {
    return '0.00';
  }
  
  const num = parseFloat(value);
  
 
  
  return num.toLocaleString('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
};



export const formatCurrency = (value, currency = 'USD', decimals = 2) => {
  if (value === null || value === undefined || isNaN(value)) {
    return '$0.00';
  }
  
  const num = parseFloat(value);
  return num.toLocaleString('en-US', {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
};

export const formatPercent = (value, decimals = 2) => {
  if (value === null || value === undefined || isNaN(value)) {
    return '0.00%';
  }
  
  const num = parseFloat(value);
  return num.toLocaleString('en-US', {
    style: 'percent',
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
};

export const formatVolume = (value) => {
  if (value === null || value === undefined || isNaN(value)) {
    return '0';
  }
  
  const num = parseFloat(value);
  
  if (num >= 1e9) {
    return (num / 1e9).toFixed(2) + 'B';
  } else if (num >= 1e6) {
    return (num / 1e6).toFixed(2) + 'M';
  } else if (num >= 1e3) {
    return (num / 1e3).toFixed(2) + 'K';
  } else {
    return num.toFixed(2);
  }
};

export const formatDate = (date, format = 'short') => {
  if (!date) return '';
  
  const d = new Date(date);
  
  switch (format) {
    case 'short':
      return d.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      });
    case 'long':
      return d.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      });
    case 'time':
      return d.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
      });
    default:
      return d.toLocaleDateString();
  }
};

export const formatAddress = (address, length = 8) => {
  if (!address || address.length <= length * 2) {
    return address;
  }
  
  return `${address.slice(0, length)}...${address.slice(-length)}`;
};

export const formatPairName = (pair) => {
  if (!pair) return '';
  return pair.replace('_', '/').replace('-', '/');
};

export const getPriceChangeColor = (change) => {
  if (change > 0) return 'text-green-600 dark:text-white';
  if (change < 0) return 'text-red-600 dark:text-red-400';
  return 'text-white dark:text-white';
};

export const getPriceChangeIcon = (change) => {
  if (change > 0) return '↑';
  if (change < 0) return '↓';
  return '→';
};

export const formatTradeType = (type) => {
  switch (type) {
    case 0:
    case 'buy':
      return 'Buy';
    case 1:
    case 'sell':
      return 'Sell';
    default:
      return type;
  }
};

export const formatOrderStatus = (status) => {
  switch (status) {
    case 0:
      return 'Open';
    case 1:
      return 'Filled';
    case 2:
      return 'Cancelled';
    default:
      return status;
  }
};

export const formatOrderType = (type) => {
  switch (type) {
    case 0:
      return 'Limit';
    case 1:
      return 'Market';
    case 2:
      return 'Stop Loss';
    case 3:
      return 'Take Profit';
    default:
      return type;
  }
};

export const truncateString = (str, maxLength = 50) => {
  if (!str || str.length <= maxLength) return str;
  return str.substring(0, maxLength) + '...';
};

export const formatFileSize = (bytes) => {
  if (bytes === 0) return '0 Bytes';
  
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
}; 